'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MODULE_NAME = '@i18n';
exports.MODULE_NAME = MODULE_NAME;